import { topLevelClass } from './src/constants'
import plugin from 'tailwindcss/plugin'
import typography from '@tailwindcss/typography'
import type { Config } from 'tailwindcss'

/**
 * Current environment is production.
 */
const isProd = process.env.NODE_ENV === 'production'

/**
 * List of colors used in the project.
 */
export const colors = {
    'deep-blue': '#000029',
    neutral: '#F2F2F2',
    'sun-yellow': '#FFCB2B',
    'earth-red': '#FF5C45',
    'light-green': '#80C29C',
    gray: '#808093',
    'dark-gray': '#666666',
    teal: '#006C7A'
}

/**
 * Full tailwind config.
 */
export default <Config>{
    important: isProd ? `.${topLevelClass}` : undefined,
    content: ['./*.html', './src/**/*.{vue,ts}'],
    theme: {
        extend: {
            colors,
            fontFamily: {
                rubik: ['Rubik', 'sans-serif'],
                sans: ['Source Sans Pro', 'sans-serif'],
                tiempos: ['Tiempos Text', 'serif']
            }
        }
    },
    plugins: [
        typography(),
        plugin(({ matchVariant }) => {
            matchVariant('screen-ratio', value => {
                const ratio = value.replace(':', '/')
                return [`@media (min-aspect-ratio: ${ratio})`]
            })
        })
    ]
}
